(function(){
     'use strict';

     angular
        .module('app')
        .factory('ContactoService', ContactoService);

    ContactoService.$inject = ['$http'];

    function ContactoService($http){


        var service= {
           getContacto:getContacto,
           sendResponder:sendResponder,
           sendReenviar:sendReenviar
        };

        return service;
 		function getContacto(vm,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var json = $('.inputsAll').serializeObject();

            var data = $.param({
               id:vm.content_id
            });
            $http.post('/backend/altcrm/forms/getcontacto', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function sendResponder(vm,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               email:vm.responder.mailto,
               asunto:vm.responder.asunto,
               mensaje:vm.responder.contacto,
               tipo:vm.tipo,
               id:vm.content_id
            });
            $http.post('/backend/altcrm/forms/sendresponder', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function sendReenviar(vm,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               email:vm.reenviar.mailto,
               asunto:vm.reenviar.asunto,
               mensaje:vm.reenviar.contacto,
               tipo:vm.tipo,
               id:vm.content_id
            });
            $http.post('/backend/altcrm/forms/sendreenviar', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
    }
})();